import { fetchAuthSession, signOut } from 'aws-amplify/auth'
import store from "@/store";
import router from "@/router";
import Cookies from "js-cookie"
import sls from "@/store/storage"

export async function fetchCurrentUserData() {
  try {
    const { tokens } = await fetchAuthSession();
    if (!tokens) throw new Error("No tokens found in session");
    const { idToken, accessToken } = tokens;
    const sessionData = {
      'accesstoken': accessToken.toString(), 
      'idtoken': idToken.toString()
    }
    // console.log("Fetched current user data:", sessionData);
    if (store.getters.getActiveSite) store.commit("setActiveSite", { ...store.getters.getActiveSite });
    store.commit("setCurrentSessionData", sessionData);
    return sessionData;
  } catch (error) {
    console.error("Error fetching current user data (Tokens expired/invalid):", error);
    
    // Delegate to the centralized Vuex logout action
    store.dispatch("forceLogout");
    throw error;
  }
}


export async function customFetch(url, method, body){
    let tokenData = await fetchCurrentUserData();
    try{
        return fetch(url, {
            method: `${method}`,
            headers: {'Content-Type': 'application/json', ...tokenData},
            body: body
        })
        .then((res) => {
            return res.json()
        })
        .then((data) => {
            return data
        })
    } catch(e)
    {
        console.log(e.message)
    }

}

export async function customFetch_POST(url, body){
    let tokenData = await fetchCurrentUserData();
    try{
        return fetch(url, {
            method: `POST`,
            headers: {'Content-Type': 'application/json', ...tokenData},
            body: body
        })
        .then((res) => {
            return res.json()
        })
        .then((data) => {
            return data
        })
    } catch(e)
    {
        console.log(e)
    }

}

export async function customFetch_PUT(url, body){
    let tokenData = await fetchCurrentUserData();
    try{
        return fetch(url, {
            method: `PUT`,
            headers: {'Content-Type': 'application/json', ...tokenData},
            body: body
        })
        .then((res) => {
            return res.json()
        })
        .then((data) => {
            return data
        })
    } catch(e)
    {
        console.log(e)
    }

}

export async function customTimeoutFetch_POST(url, body){
    let tokenData = await fetchCurrentUserData();
    try{
        return fetch(url, {
            method: `POST`,
            timeout: 20000,
            headers: {'Content-Type': 'application/json', ...tokenData},
            body: body
        })
        .then((res) => {
            return res.json()
        })
        .then((data) => {
            return data
        })
    } catch(e)
    {
        console.log(e)
    }

}